
import { ReactNode } from "react";

interface SectionTitleProps {
  subtitle?: string;
  title: string;
  description?: string;
  alignment?: 'left' | 'center' | 'right';
  className?: string;
  icon?: ReactNode;
}

export const SectionTitle = ({
  subtitle,
  title,
  description,
  alignment = 'center',
  className = '',
  icon,
}: SectionTitleProps) => {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto',
  };

  return (
    <div className={`max-w-3xl mb-12 ${alignmentClasses[alignment]} ${className}`}>
      {icon && (
        <div className="flex justify-center mb-4">
          {icon}
        </div>
      )}
      {subtitle && (
        <span className="block text-dental-highlight font-medium mb-2 uppercase tracking-wider text-sm animate-fade-in">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-4 animate-fade-in">
        {title}
      </h2>
      {description && (
        <p className="text-dental-muted text-lg animate-fade-in-up">
          {description}
        </p>
      )}
    </div>
  );
};
